import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: notifications.NotificationRecipient.
export default class Recipient extends Fragment {
  declare [Type]: 'notifications/recipient';

  @attr('string', { defaultValue: '' })
  declare personId: string;

  @attr('string', { defaultValue: '' })
  declare salutation: string;

  @attr('string', { defaultValue: '' })
  declare personalisedMessage: string;
}
